module.exports = __webpack_public_path__ + "media/images/flags/mt-d72a37c0792ea448ece37308008f1138.svg";